export default {
  loginSchema: (state, getters) => {
    if (state.loginSchema) {
      return state.loginSchema
    } else {
      return null
    }
  },
  loggedIn (state, getters) {
    return state.loggedIn
  },
  passwordReset (state, getters) {
    return state.passwordReset
  },
  getToken: (state, getters) => {
    if (state.token) {
      return 'Bearer ' + state.token.access_token.replace(/(^")|("$)/g, '')
    } else {
      return null
    }
  },
  getSocketToken: (state, getters) => {
    if (state.token) {
      return state.token.access_token.replace(/(^")|("$)/g, '')
    } else {
      return null
    }
  },
  getRefreshToken: (state, getters) => {
    if (state.token) {
      return state.token.refresh_token.replace(/(^")|("$)/g, '')
    } else {
      return null
    }
  },
  forgotPasswordSchema: (state, getters) => {
    if (state.forgotPasswordSchema) {
      return state.forgotPasswordSchema
    } else {
      return null
    }
  },
  resetPasswordSchema: (state, getters) => {
    if (state.resetPasswordSchema) {
      return state.resetPasswordSchema
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/login/getters.js